import { render, staticRenderFns } from "./diapositiva-6.vue?vue&type=template&id=b66fe7a4&scoped=true&"
import script from "./diapositiva-6.vue?vue&type=script&lang=js&"
export * from "./diapositiva-6.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-6.vue?vue&type=style&index=0&id=b66fe7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66fe7a4",
  null
  
)

export default component.exports